<template>
  <div class="equipment_list_nav">
    <span>{{ navObj.title }}</span>
    <ul>
      <li
        @click="categoryChange(item)"
        :class="item.id == currentCategory ? 'active' : ''"
        v-for="(item, index) in navObj.list"
        :key="index"
      >
        {{ item.name }}
      </li>
    </ul>
    <p @click="goToUrl('/classification_list')">更多></p>
  </div>
</template>

<script>
import {routerGoNewpage } from "@/utils/index";
export default {
  props: {
    navObj: Object,
  },
  data() {
    return {
      currentCategory: "",
    };
  },
  created(){
       this.currentCategory = this.navObj.list && this.navObj.list[0].id;
  },
  methods: {
    goToUrl(url) {
      routerGoNewpage(url,{categroyid:this.navObj.cateid})
    },
    categoryChange(item){
        this.currentCategory = item.id;
        this.$emit("change",this.currentCategory)
    }
  },
};
</script>

<style scoped lang='less'>
.equipment_list_nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  span {
    position: relative;
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    margin-left: 15px;
    margin-right: 20px;
    &::before {
      position: absolute;
      left: -15px;
      bottom: 4px;
      display: inline-block;
      content: "";
      width: 5px;
      height: 23px;
      background: #ff7302;
    }
  }
  p {
    cursor: pointer;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }
  ul {
    display: flex;
    position: absolute;
    left: 15%;
    flex:1;
    li {
      cursor: pointer;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin-right: 15px;
    }
    .active {
      border-bottom: 2px solid #ff7302;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/common/equipmentNav.vue